import angular from 'angular';
import 'angular-ui-router';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './sidebar.jade';
import {fetchFullGameAndCallOnNext} from '../util/game-util.js';

export class SidebarController {
  /* @ngInject */
  constructor($state, $window, currentUser, currentGame, hideThatProduct) {
    this.$state = $state;
    this.currentGame = currentGame;
    this.hideThatProduct = hideThatProduct;
    this.hideMfaDisabled = true;
    this.$window = $window;

    currentGame.subscribe(game => this.game = game);
    currentUser.subscribe(user => {
      if (user) {
        this.user = user;
        this.hideMfaDisabled = !user.use_mfa && !user.hasRole(['DEMO']);
        this.hideAcquisitionProduct = this.hideThatProduct.hideAcquisitionProduct(user);
      }
    });
  }

  isAffleDomain() {
    return this.$window.location.href && this.$window.location.href.includes("mdsp.affle.com");
  }

  isDemo() {
    return this.user && typeof this.user.hasRole === 'function' ? this.user.hasRole(['DEMO']) : false;
  }
}

export function SidebarComponent() {
  return {
    template,
    controller: SidebarController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('sidebar', [
  ServicesModule.name,
  ResourcesModule.name
])
.directive('sidebar', SidebarComponent);



/** WEBPACK FOOTER **
 ** ./src/common/sidebar/sidebar.js
 **/